
    import '/home/ec2-user/Youlify-Design/components/chips/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["chips-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/chips/index.en-US.md?type=demo')
};